import { ElementRef, Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbItemsObserverService {
  private items = new BehaviorSubject<ElementRef[]>([])
  private pageInView = new BehaviorSubject<number>(0)

  constructor() {}

  setItemsToObserve(items: ElementRef[] | undefined): void {
    if (items) this.items.next(items)
  }

  getItemsToObserve(): Observable<ElementRef[]> {
    return this.items.asObservable()
  }

  setPageInView(pageInView: number): void {
    this.pageInView.next(pageInView)
  }

  getPageInView(): Observable<number> {
    return this.pageInView.asObservable()
  }
}
